import script from "./publishDemand.vue?vue&type=script&lang=ts&setup=true"
export * from "./publishDemand.vue?vue&type=script&lang=ts&setup=true"

import "./publishDemand.vue?vue&type=style&index=0&id=0bf9715e&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf9715e"]])

export default __exports__